<router-outlet></router-outlet>
<app-logo-area [breadcrumbs]="breadCrumbs()"></app-logo-area>
<main>
  <app-headline-section [title]="'Remote Desktop'" [loading]="loading$()">
  </app-headline-section>

  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-8">
          <p class="cl-p-large">Manage desktop hosts and editing workspaces.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="cl-section cl-section-regular">
    <div class="container">
      @if (combined$() === undefined) {
        <table class="cl-table-data">
          <thead><tr><th class="cl-table-head cl-p-tiny">Name</th><th class="cl-table-head cl-p-tiny">State</th><th class="cl-table-head cl-p-tiny"></th></tr></thead>
          <tbody><tr class="cl-tr-no-data"><td colspan="100" style="text-align: center"><div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i></div></td></tr></tbody>
        </table>
      } @else if (regionView$().length === 0) {
        <table class="cl-table-data">
          <thead><tr><th class="cl-table-head cl-p-tiny">Pool</th><th class="cl-table-head cl-p-tiny">Name</th><th class="cl-table-head cl-p-tiny">State</th><th class="cl-table-head cl-p-tiny">Details</th><th class="cl-table-head cl-p-tiny"></th></tr></thead>
          <tbody><tr class="cl-tr-no-data"><td colspan="100" style="text-align: center">No desktop hosts or editing workspaces found.</td></tr></tbody>
        </table>
      } @else {
        @for (rv of regionView$(); track rv.region) {
          <h3 class="cl-h4 ps-2">{{ rv.city }} <small class="text-muted">({{ rv.region }})</small></h3>
          <table class="cl-table-data">
            <thead>
            <tr>
              <th class="cl-table-head cl-p-tiny">Pool</th>
              <th class="cl-table-head cl-p-tiny">Name</th>
              <th class="cl-table-head cl-p-tiny">State</th>
              <th class="cl-table-head cl-p-tiny">Details</th>
              <th class="cl-table-head cl-p-tiny"></th>
            </tr>
            </thead>
            <tbody>

            <!-- Unassigned editing workspaces -->
            @for (ws of rv.unassigned; track ws.id) {
              <tr>
                <td>{{ ws.pool }}</td>
                <td>
                  <i class="fas fa-hdd text-muted" style="margin-right: 0.4em"></i>
                  <strong>{{ ws.mountPoint || '-' }}</strong>
                  <br><small class="text-muted">{{ ws.volumeSizeGiB }} GiB &middot; {{ ws.availabilityZone }} &middot; {{ volumeId(ws) }}</small>
                </td>
                <td>
                  <span class="cl-badge cl-badge-sm" [ngClass]="getEditStatusClass(ws.status)">{{ getEditStatusLabel(ws.status) }}</span>
                </td>
                <td>
                  <span class="cl-font-monospace">{{ ws.createdAt ? (formatTimestamp(ws.createdAt) | cldate) : '' }}</span>
                  @if (ws.errorMessage) {
                    <br><small class="cl-color-brick">{{ ws.errorMessage }}</small>
                  }
                </td>
                <td class="cl-td-links" width="1%">
                  @if (isMountable(ws) || isMounting(ws)) {
                    @if (isMounting(ws)) {
                      <a class="cl-a-btn cl-a-primary disabled"><i class="fas fa-spinner fa-spin"></i> Mount</a>
                    } @else if (hostsInSameAz(ws).length > 0) {
                      <a class="cl-a-btn cl-a-primary" (click)="showMountDialog(ws)">Mount</a>
                    } @else {
                      <small class="text-muted">No host in {{ ws.availabilityZone }}</small>
                    }
                  }
                  <a class="cl-a-btn" [processButton]="'unmount-' + ws.id + '-DELETE'" (click)="unmountWorkspace(ws, 'DELETE')">Delete</a>
                </td>
              </tr>
            }

            <!-- Hosts with their mounted workspaces -->
            @for (hv of rv.hosts; track hv.host.instanceId) {
              <!-- Host row -->
              <tr class="host-row">
                <td>{{ hv.host.pool }}</td>
                <td>
                  <i class="fas fa-desktop" style="margin-right: 0.4em"></i>
                  <strong>{{ hv.host.name || hv.host.instanceId }}</strong>
                  <br><small class="text-muted">{{ hv.host.instanceId }} &middot; {{ hv.host.instanceType }} &middot; {{ hv.host.availabilityZone }}</small>
                </td>
                <td>
                  @switch (hv.host.state) {
                    @case ('registered') { <span class="cl-badge cl-badge-sm cl-color-leaf">Ready</span> }
                    @case ('in_use') { <span class="cl-badge cl-badge-sm cl-color-leaf">Connected</span> }
                    @case ('not_registered') { <span class="cl-badge cl-badge-sm cl-color-honey">Not Registered</span> }
                    @case ('stopped') { <span class="cl-badge cl-badge-sm cl-color-ash">Stopped</span> }
                    @case ('stopping') { <span class="cl-badge cl-badge-sm cl-color-honey">Stopping</span> }
                    @case ('pending') { <span class="cl-badge cl-badge-sm cl-color-honey">Starting</span> }
                    @case ('terminated') { <span class="cl-badge cl-badge-sm cl-color-brick">Terminated</span> }
                    @default { <span class="cl-badge cl-badge-sm cl-color-ash">{{ hv.host.state }}</span> }
                  }
                </td>
                <td>
                  <span class="cl-font-monospace">{{ hv.host.publicIp || '' }}</span>
                  @if (hv.host.setupDate) {
                    <br><small class="text-muted">bootstrapped <span class="cl-font-monospace">{{ hv.host.setupDate | cldate }}</span></small>
                  } @else {
                    <br><small class="text-muted cl-color-honey">not bootstrapped</small>
                  }
                </td>
                <td class="cl-td-links" width="1%">
                  @if (hv.host.state === 'stopped') {
                    @if ('contentplatform:repository:Mutation/StartDesktopHost' | isAllowedAnywhere: organization()) {
                      <a class="cl-a-btn cl-a-primary" [processButton]="'start-' + hv.host.instanceId" (click)="startSession(hv.host)">Start</a>
                    }
                    @if ('contentplatform:repository:Mutation/SetupDesktopHost' | isAllowedAnywhere: organization()) {
                      <a class="cl-a-btn" [processButton]="'setup-' + hv.host.instanceId" (click)="setupSession(hv.host)">Setup</a>
                    }
                  } @else if (hv.host.state === 'registered' || hv.host.state === 'in_use' || hv.host.state === 'not_registered') {
                    @if ((hv.host.state === 'registered' || hv.host.state === 'in_use') && ('contentplatform:repository:Mutation/JoinCrdSession' | isAllowedAnywhere: organization())) {
                      <a class="cl-a-btn cl-a-primary"
                         [routerLink]="['join', hv.host.pool, hv.host.instanceId]"
                         [queryParams]="{hostName: hv.host.name || hv.host.instanceId, region: hv.host.awsRegion, monitor: 0}">Screen 1</a>
                      <a class="cl-a-btn"
                         [routerLink]="['join', hv.host.pool, hv.host.instanceId]"
                         [queryParams]="{hostName: hv.host.name || hv.host.instanceId, region: hv.host.awsRegion, monitor: 1}">Screen 2</a>
                      <a class="cl-a-btn"
                         [routerLink]="['join', hv.host.pool, hv.host.instanceId]"
                         [queryParams]="{hostName: hv.host.name || hv.host.instanceId, region: hv.host.awsRegion, monitor: 2}">Screen 3</a>
                    }
                    @if ('contentplatform:repository:Mutation/SetupDesktopHost' | isAllowedAnywhere: organization()) {
                      <a class="cl-a-btn" [processButton]="'setup-' + hv.host.instanceId" (click)="setupSession(hv.host)">Setup</a>
                    }
                    @if ('contentplatform:repository:Mutation/StopDesktopHost' | isAllowedAnywhere: organization()) {
                      <a class="cl-a-btn" [processButton]="'stop-' + hv.host.instanceId" (click)="stopSession(hv.host)">Stop</a>
                    }
                  }
                </td>
              </tr>

              <!-- Mounted workspaces under this host -->
              @for (ws of hv.workspaces; track ws.id) {
                <tr class="workspace-row">
                  <td>{{ ws.pool }}</td>
                  <td style="padding-left: 2rem">
                    <i class="fas fa-hdd text-muted" style="margin-right: 0.4em"></i>
                    {{ ws.driveLetter }}: <strong>{{ ws.mountPoint }}</strong>
                    <br><small class="text-muted" style="padding-left: 1rem">{{ ws.volumeSizeGiB }} GiB &middot; {{ ws.awsRegion }} &middot; {{ volumeId(ws) }}</small>
                  </td>
                  <td>
                    <span class="cl-badge cl-badge-sm" [ngClass]="getEditStatusClass(ws.status)">{{ getEditStatusLabel(ws.status) }}</span>
                  </td>
                  <td><span class="cl-font-monospace">{{ ws.createdAt ? (formatTimestamp(ws.createdAt) | cldate) : '' }}</span></td>
                  <td class="cl-td-links" width="1%">
                    <a class="cl-a-btn" [processButton]="'unmount-' + ws.id + '-UNMOUNT'" (click)="unmountWorkspace(ws, 'UNMOUNT')">Unmount</a>
                    <a class="cl-a-btn" [processButton]="'unmount-' + ws.id + '-COPY_BACK'" (click)="unmountWorkspace(ws, 'COPY_BACK')">Copy Back</a>
                    <a class="cl-a-btn" [processButton]="'unmount-' + ws.id + '-DELETE'" (click)="unmountWorkspace(ws, 'DELETE')">Delete</a>
                  </td>
                </tr>
              }
            }

            </tbody>
          </table>
        }
      }
    </div>
  </section>
</main>
